
<div class="container my-4 contactContent" id="">
  <h3 class="page-title">{{'ContactAssessor.TitleTaxSavings'|translate}}</h3>
  <p style="margin-bottom: 0;">{{'ContactAssessor.PleaseVisit'|translate}} </p>
  <p [innerHTML]="'ContactAssessor.Links' | translate"></p>

  <p >{{'ContactAssessor.AdditionalInfo'|translate}}</p>

  <p style="font-style: italic"><strong>{{'ContactAssessor.Number'|translate}} </strong></p>
  <hr>
    <form [formGroup]="contactForm" (ngSubmit)="submit()">
      <p class="form-label">{{'ContactAssessor.Name'|translate}} <span class="color-red">*</span></p>
      <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px; margin-bottom: 20px;">
        <div class="form-group col-md-6" style="display: flex; flex-direction: column; align-items: center; width: 49%;">

          <input type="text" formControlName="firstName" class="form-control" id="inputFirst-General" placeholder="{{'ContactAssessor.FirstName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('firstName', 'required')) {
              {{'ContactAssessor.Required'|translate}}
            }
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" formControlName="lastName" class="form-control" id="inputLast-General" placeholder="{{'ContactAssessor.LastName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('lastName', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 20px;">
        <p class="form-label">{{ 'ContactAssessor.Email' | translate}} <span class="color-red">*</span></p>
        <input type="email" class="form-control" formControlName="email" placeholder="{{'ContactAssessor.Email' | translate}}">
        <div class="invalid-feedback" style="display: block">
          @if (hasError('email', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>
      <p class="form-label">{{ 'ContactAssessor.Phone' | translate}}  <span class="color-red">*</span></p>
      <div class="form-row">
        <div class="form-group col-12" style="margin-bottom: 20px;">
          <input class="form-control"  type="text" appPhoneMask placeholder="{{'ContactAssessor.Phone' | translate}}"  formControlName="phone" id="inputPhone-General"  >
          <div class="invalid-feedback" style="display: block">
            @if (hasError('phone', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>

      <div class="form-group">
        <p class="form-label">AIN ({{ 'ContactAssessor.Ain' | translate}})</p>
        <input type="text" class="form-control" appAinMask formControlName="ain" placeholder="XXXX-XXX-XXX">

      </div>

      <p class="form-label"  style="margin-top: 20px;" >{{'ContactAssessor.Address'| translate}} <span class="color-red">*</span></p>
      <app-certificate-address
        [parentFormGroup]="contactForm"
        streetNumber="number"
        streetDirection="direction"
        streetName="street"
        streetType="type"
        unitNumber="unit"
        city="city"
        zipCode="zipCode"

        >
      </app-certificate-address>


      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.TaxInquiry' | translate}} <span class="color-red">*</span></p>
      <div class="form-group">
        <select formControlName="inquiry"  class="form-select">
          <option selected value="">Select..</option>
          <option>Homeowners’ Exemption </option>
          <option>Veterans’ Exemption </option>
          <option>Disabled Veterans</option>
          <option>Decline-in-Value </option>
          <option>Mills Act </option>
          <option>Churches and Religious</option>
          <option>Other</option>
        </select>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('inquiry', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>

      <p class="form-label" style="margin-top: 20px;">
        {{'ContactAssessor.StatusRadio' | translate}} <span class="color-red">*</span>
      </p>
      <div class="form-group d-flex align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" formControlName="claimStatus" value="Yes" name="claimStatus" type="radio" id="claimStatusYes">
          <label class="form-check-label" for="claimStatusYes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" formControlName="claimStatus" value="No" name="claimStatus" type="radio" id="claimStatusNo">
          <label class="form-check-label" for="claimStatusNo">No</label>
        </div>
      </div>
      <div class="invalid-feedback d-block">
        @if (hasError('claimStatus', 'required')) {
          {{ 'ContactAssessor.Required' | translate}}
        }
      </div>


      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Description' | translate}}</p>
      <div class="form-group">

        <textarea class="form-control" formControlName="description"  id="inputDescription-General" rows="4" placeholder="Type here"></textarea>
      </div>
      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Attachment' | translate}} (PDF or Docx)</p>
      <div class="form-group">
        <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('file', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
          @if (hasError('file', 'requiredFileType')) {
            Only PDF, Docx
          }
          @if (hasError('file', 'requiredFileSize')) {
            Size to exceeds 10 MB
          }
        </div>
      </div>


      <div class="form-group" style="margin-top: 15px;">
        <app-captcha [form]="contactForm" captchaFieldName="recaptchaReactive"></app-captcha>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('recaptchaReactive', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>

      <button type="submit" class="btn btn-primary mr-4" style="margin-top: 15px;">Submit</button>@if (success) {
      <span>Successfully Submitted</span>
    }

  </form>

</div>
